// extracted by mini-css-extract-plugin
export var childrenContainer = "_4j-0";
export var virtualScrollArea = "_4j-1";